export const GoogleMapApiConfig = 'AIzaSyAUdUa7x__u9LidftJ-mSNOAf3KFCRktos';